<section class="diag_area">
    <div class="diag_flex">
        <div class="column_one">
            <div class="colone_banner">
                <div class="logo_ctr">
                    <figure class="mb-0">
                        <img src="assets/img/diagnostic/ilwhite.png" alt="logo" class="dia_logo">
                    </figure>
                </div>
                <div class="colone_maintxt">
                    <p class="dia_mntxt">Take the test & identify your strengths & <br> weaknesses to upgrade your
                        learning</p>
                    <figure class="mb-0">
                        <img src="assets/img/diagnostic/diarohit.png" alt="rohit" class="diarohit">
                        <img src="assets/img/diagnostic/mobdiarohit.png" alt="rohit" class="mobdiarohit">
                    </figure>
                </div>
            </div>
            <div class="dia_termsbg">
                <p class="dia_rules"><a class="dia_terms">Terms & Conditions </a> | <a class="dia_terms"> Privacy
                        Policy</a></p>
            </div>
        </div>
        <div class="column_two">
            <div class="col-md-12 col-lg-12 col-12">
                <div>
                    <div class="coltwo_cntr">
                        <figure class="mb-0">
                            <img src="assets/img/diagnostic/ilwhite.png" alt="logo" class="mob_dia_logo">
                            <img src="assets/img/diagnostic/congrats.png" alt="congrats" class="dia_congrat">
                        </figure>
                        <p class="mob_dia_mntxt">Take the test & identify your strengths & <br> weaknesses to upgrade
                            your learning</p>
                        <h6 class="dia_assesstest">You have unlocked a highly specialised <br> assessment test @ Rs 99/-
                        </h6>
                        <p class="dia_signtxt">For Sign Up, please provide below information</p>
                    </div>
                    <div class="coltwo_form">
                        <ng-container *ngIf="diagnosticUtility?.mode == 'login' ">
                        <form class="form_style" #egisform="ngForm">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="dialabel">First Name</label>
                                    <input type="text" class="UNFAPP-form-fld" placeholder="First Name"  name ="firstName" [(ngModel)]="loginData.firstName">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="dialabel">Last Name</label>
                                    <input type="text" class="UNFAPP-form-fld" placeholder="Last Name" name ="lastName" [(ngModel)]="loginData.lastName">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="dialabel">Your Mobile number</label>
                                    <div class="UNFAPP-form-fld-row">
                                        <div class="UNFAPP-form-fld-wrp UNFAPP-phncuntry-drpdwn UNFAPP-wthicon">
                                            <span class="UNFAPP-frmicon">
                                                <img src="assets/img/diagnostic/phone-icon.png" alt="" /></span>
                                            <div class="UNFAPP-phncuntry-fldgrp">
                                                <select>
                                                    <option>+91</option>
                                                </select>
                                                <input type="text" placeholder="Phone Number"  name ="phone"[(ngModel)]="loginData.phone"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" name ="whatsappConsent" value="value2" [(ngModel)]="loginData.whatsappConsent"
                                        checked>
                                    <label for="styled-checkbox-2">Receive updates on Whatsapp By signing up you agree
                                        to our <a class="dia_policy">T&C</a> and <a class="dia_policy">Privacy
                                            Policy</a></label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <button type="button" class="diag_genotp" id="btn-otp" (click)="otpLogin()">Generate OTP</button>
                                </div>
                            </div>
                            </form>
                        </ng-container>
                            <div class=" "*ngIf="diagnosticUtility?.mode == 'otp' ">
                                 <form #otpform="ngForm">
                                <div class="row">
                                    <div class="col-md-12" id="txt-edit">
                                        <p class="dia_otpbold">OTP sent to +91 {{loginData?.phone}} Please enter the same OTP
                                            below</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="inputbox">
                                            <ng-otp-input (onInputChange)="onOtpChange($event)" id="otpboxes" [config]="config"></ng-otp-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 text-center mb_30">
                                        <button class="dia_resendotp" [disabled]="diagnosticUtility.resendOtpBtn"(click)="genarateOTP()" >Resend OTP {{diagnosticUtility.counter}}</button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox"
                                            value="value2" checked>
                                        <label for="styled-checkbox-2">Receive updates on Whatsapp By signing up you
                                            agree to our <a class="dia_policy">T&C</a> and <a class="dia_policy">Privacy
                                                Policy</a></label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button type="button" class="diag_genotp" [disabled]="diagnosticUtility.otpValid" (click)="validateOtp()"id="btn-otp">Next</button>
                                    </div>
                                </div>
                            </form>
                            </div>
                            <div class=" " *ngIf="diagnosticUtility?.mode == 'grade'">
                                <form  #gradeform="ngForm">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="dialabel">Select your Grade</label>
                                        <div class="view_btns">
                                            <ng-container  *ngFor="let gr of grades">
                                                <a href="javascript:void(0)" class="mr_5 mb_10  small_blue_btn  " (click)="selectGrade(gr.name)" [ngClass] ="{'active': diagnosticUtility.slectedGrade ==  gr.name}">{{gr.display}}</a>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="dialabel">Select your target exam</label>
                                        <div class="view_btns">
                                            <ng-container *ngFor="let gr of grade_examCombination[diagnosticUtility.slectedGrade]">

                                                <a href="javascript:void(0)" (click)="selectExam(gr)"  class="mr_5 mb_10  grsmall_blue_btn "[ngClass] ="{'active': diagnosticUtility.slectedexam ==  gr}"> {{gr}}</a>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="dialabel">Email</label>
                                        <input type="text" class="UNFAPP-form-fld" placeholder="Email" name="email"  [(ngModel)]="loginData.email">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="dialabel">Pincode</label>
                                        <input type="text" class="UNFAPP-form-fld" placeholder="Pincode" name="picode" [(ngModel)]="loginData.pincode">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="dialabel">Select State</label>
                                        <select class="UNFAPP-form-fld" name="state" [(ngModel)]="loginData.state" >
                                            <option value="">Select State</option>
                                            <option *ngFor=" let state of diagnosticUtility.states" [value]="state.abbreviation">{{state?.name}}</option>
                                          
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox"
                                            value="value2" checked>
                                        <label for="styled-checkbox-2">Receive updates on Whatsapp By signing up you
                                            agree to our <a class="dia_policy">T&C</a> and <a class="dia_policy">Privacy
                                                Policy</a></label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button type="button" [disabled]="!loginData.state  || !loginData.pincode || !loginData.email " class="diag_genotp" (click) ="getTimeSlots()" id="btn-otp">Next</button>
                                    </div>
                                </div>
                                </form>
                            </div>

                            <div class=" " *ngIf="diagnosticUtility?.mode == 'buy'">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="dialabel">Select Date</label>
                                        <select class="UNFAPP-form-fld" name="timeSlots" (change)="dateChange($event)" >
                                            <option value="">select Date</option>
                                            <option *ngFor="let date of diagnosticUtility.displayFormat" [value]="date.date" >{{date.date}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="dialabel">Select Time</label>
                                        <div class="view_btns">
                                            <a href="javascript:void(0)" *ngFor="let slot of diagnosticUtility.selecteddate?.avaibleSlots" class="mr_5 mb_10  grsmall_blue_btn" [ngClass]="{'active': diagnosticUtility.timeSlotSelection?.time== slot?.time}" (click)="selectslotOption(slot)">{{slot?.time}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox"
                                            value="value2" checked>
                                        <label for="styled-checkbox-2">Receive updates on Whatsapp By signing up you
                                            agree to our <a class="dia_policy">T&C</a> and <a class="dia_policy">Privacy
                                                Policy</a></label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button type="button" class="diag_genotp mb_20" id="btn-otp" [disabled]="!diagnosticUtility.timeSlotSelection?.time" (click)="buyPackage()">Buy Now</button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button type="button" class="diag_backbtn" id="btn-otp" (click)="diagnosticUtility.mode = 'grade'">Back</button>
                                    </div>
                                </div>
                            </div>
                        
                 
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>